import { createFileRoute } from '@tanstack/react-router';
import { UsagePage } from '../../pages/UsagePage';
import { ensureCatalogEntries } from '../../features/catalog/queries';
import { loadMeasuredFigures } from '../../features/usage/queries';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/usage')({
  // Without its own description this page inherited the root default, which is
  // the homepage's - two indexed URLs describing themselves identically.
  head: () =>
    staticPageHead({
      path: '/usage',
      title: 'Network Usage - AnyAPI',
      description:
        'See live request volume, latency, and uptime across the AnyAPI network, endpoint by endpoint.',
      crumb: 'Network usage',
    }),
  // The page IS the figures, so they are resolved before it renders: the whole
  // record then reaches a crawler, an agent reading the Markdown, and a reader
  // with no JavaScript, instead of the word "Loading". `loadMeasuredFigures`
  // never rejects, so a metrics hiccup degrades the table rather than the page.
  loader: ({ context }) =>
    Promise.all([ensureCatalogEntries(context.queryClient), loadMeasuredFigures(context.queryClient)]),
  component: UsagePage,
});
